/**
 * @author Mikhail.Kokoulin
 * @version 1.0.0
 */
import produce from 'immer';

/**
 * @description Interface for Initial state for global reducer
 * @interface IGlobalReducer
 * @property{loading} required to display the loader
 */
export interface IGlobalReducer {
}

/**
 * @description Initial state for global reducer
 * @type {{loading: boolean}}
 */
export const initialState: IGlobalReducer = {
};

/**
 * @description Reducer for control global state
 * @param {IGlobalReducer} state
 * @param action
 * @returns {Produced<IGlobalReducer, void>}
 */
const globalReducer = (state = initialState, action: any) =>
    produce(state, () => {
        switch (action.type) {
            default:
                return state;
        }
    });

export default globalReducer;
